/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Our_4Inputs */



/**
* | output |
* | --- |
* | "Technical support according to your service level agreement" |
*
* @param {Guardrails_Section_3_Our_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_our_4 = /** @type {((inputs?: Guardrails_Section_3_Our_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Our_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Technischer Support gemäß Ihrem Service Level Agreement")
	return /** @type {LocalizedString} */ ("Technical support according to your service level agreement")
});